export default "__VITE_ASSET__1c2o__yL__"